import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { initSentry } from './lib/sentry'
import App from './App.tsx'
import './index.css'

initSentry()

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Something went wrong. Refresh to try again.</div>}>
    <App />
  </Sentry.ErrorBoundary>
);
